export default {
  transfer_suceeded: 'Tokens successfully sent'
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/transfers.js